import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
    cardLoaderContainer: {
        padding: '5px 10px',
        width: '100%',
    },
}));
